import { createSelector } from "./createSelector.js";
import * as selectors from "./selectors.js";
export const select = Object.assign((...args) => createSelector(...args), selectors);
